export * from './patient.service';
export * from './patient';
export * from './patient.component';
export * from './patient-list.component';